(function(){
  'use strict';
  function init(){
    var toggle=document.querySelector('[data-ssg-menu-toggle]');
    var menu=document.getElementById('ssg-mobile-menu');
    var strip=document.querySelector('[data-ssg-install-strip]');
    var trigger=document.querySelector('[data-ssg-install-trigger]');
    var backdrop=document.querySelector('[data-ssg-install-backdrop]');
    var close=document.querySelector('[data-ssg-install-close]');
    var help=document.querySelector('[data-ssg-install-help]');
    var nativeButton=document.querySelector('[data-ssg-native-install]');
    var nativePrompt=null;
    function openMenu(open){if(!toggle||!menu)return;menu.hidden=!open;toggle.setAttribute('aria-expanded',open?'true':'false');toggle.setAttribute('aria-label',open?'Close navigation menu':'Open navigation menu');}
    if(toggle){toggle.addEventListener('click',function(){openMenu(menu.hidden);});}
    document.addEventListener('click',function(e){if(!menu||menu.hidden)return;if(!menu.contains(e.target)&&!toggle.contains(e.target))openMenu(false);});
    function openInstructions(){
      if(!backdrop)return;
      var ios=/iPad|iPhone|iPod/i.test(navigator.userAgent);
      var isSafari=/Safari/i.test(navigator.userAgent)&&!/CriOS|FxiOS|EdgiOS/i.test(navigator.userAgent);
      if(help){
        help.innerHTML=ios
          ? '<strong>On iPhone / iPad:</strong> open SoulStone in Safari, tap the Share icon (square with the upward arrow), choose <strong>Add to Home Screen</strong>, then tap <strong>Add</strong>.'
          : '<strong>On Android:</strong> open your browser menu (⋮) and tap <strong>Add to Home screen</strong> or <strong>Install app</strong>. Confirm <strong>Add</strong>.';
        if(ios&&!isSafari)help.innerHTML+='<br>Copy the website link into Safari first.';
      }
      if(nativeButton)nativeButton.hidden=!nativePrompt;
      backdrop.hidden=false;document.body.style.overflow='hidden';
      if(close)close.focus();
    }
    function closeInstructions(){if(!backdrop)return;backdrop.hidden=true;document.body.style.overflow='';if(trigger)trigger.focus();}
    if(close)close.addEventListener('click',closeInstructions);
    if(backdrop)backdrop.addEventListener('click',function(e){if(e.target===backdrop)closeInstructions();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){openMenu(false);if(backdrop&&!backdrop.hidden)closeInstructions();}});
    var standalone=(window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||navigator.standalone===true;
    if(standalone){document.documentElement.classList.add('ssg-installed');if(strip)strip.hidden=true;}
    window.addEventListener('beforeinstallprompt',function(e){e.preventDefault();nativePrompt=e;if(nativeButton)nativeButton.hidden=false;});
    window.addEventListener('appinstalled',function(){document.documentElement.classList.add('ssg-installed');closeInstructions();});
    function invokeNative(){
      if(!nativePrompt){openInstructions();return;}
      var p=nativePrompt;nativePrompt=null;p.prompt();Promise.resolve(p.userChoice).then(function(){if(nativeButton)nativeButton.hidden=true;}).catch(function(){openInstructions();});
    }
    if(trigger)trigger.addEventListener('click',function(){if(nativePrompt)invokeNative();else openInstructions();});
    if(nativeButton)nativeButton.addEventListener('click',invokeNative);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();